import { Grid } from '@mui/material';
import FormCard from 'components/FormCard';
import DriverDetailsForm from 'components/forms/DriverFormFactory/DriverDetailsForm';
import DriverImageForm from 'components/forms/DriverFormFactory/DriverImageForm';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useOperatorsDriversFilesQuery, useOperatorsDriversQuery } from 'api/queries/operators';
import { FileTypeEnum } from 'remote/global';

function DriverDetailView() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data: driver, isSuccess: isDriverSuccess } = useOperatorsDriversQuery(id!);
  const { data: driverFiles, isSuccess: isFilesSuccess } = useOperatorsDriversFilesQuery(id!);

  if (!isDriverSuccess || !isFilesSuccess) return null;

  const files = driverFiles.filter((f) => f.fileType === FileTypeEnum.DRIVER_PHOTO);

  return (
    <Grid container>
      <Grid
        item
        width='421px'
        textAlign='left'
        mr='24px'
        mb={{
          xs: '24px',
          lg: 0,
        }}
      >
        {driver != null && (
          <FormCard title={t('DriversView.DetailView.driverDetails.title')}>
            <DriverDetailsForm defaultValues={driver} driverId={id as string} />
          </FormCard>
        )}
      </Grid>
      <Grid item width='421px' textAlign='left'>
        <FormCard title={t('DriversView.DetailView.driverImages.title')}>
          <DriverImageForm
            // Only spread defaultValues if the attachments is present
            // Because we want the component to stay in 'undefined' for correct error handling
            {...(files.length > 0 && { defaultValues: { attachments: files } })}
            driverId={id as string}
          />
        </FormCard>
      </Grid>
    </Grid>
  );
}

export default DriverDetailView;
